<div>
    <div class="row">
        <div class="col-xl-12">
            <div class="card-box">
                <div v-if="!loading">
                    <data-table :headings="zonesHeadings" :data="zones" :hasActions="true"
                                :hasNoPaging="true"
                                :pagingDetails="pagingDetails"
                                :stateChanged="filterStateChanged"
                                @actionClicked="onZoneActionClicked" 
                                @filterSearchClicked="onFilterSearchClicked">
                        <template #actionButton>
                            <div class="w-100">
                                <button id="btnAddZone" class="btn btn-primary" @click="onAddZoneClick">Add Zone</button>
                            </div>
                        </template>
                        <template #filter>
                            <div class="p-3">
                                <div class="input-group pb-4">
                                    <input type="text" class="form-control" placeholder="Search" aria-label="Search" aria-describedby="basic-addon1" v-model="filter.customerSearchQuery">
                                    <div class="input-group-append">
                                    <span class="input-group-text" id="basic-addon1">
                                        <i class="fas fa-search"></i>
                                    </span>
                                    </div>
                                </div>
                                <active-inactive-radio-buttons :activeInactiveKey="filter.activeOrInactiveItems"
                                                               :componentId="'customerFilterRadioButtons'"
                                                               @activeInactiveSelected="onActiveInactiveFilterSelected"></active-inactive-radio-buttons>
                            </div>
                        </template>
                    </data-table>
                </div>
                <loading-spinner :showSpinner="loading"></loading-spinner>
            </div>
        </div>
    </div>

    <mark-as-active-inactive-modal
                :heading="zoneMarkAsActiveInactiveModal.heading"
                :modalId="zoneMarkAsActiveInactiveModal.modalId"
                :isSaving="zoneMarkAsActiveInactiveModal.isSaving"
                :showModal="zoneMarkAsActiveInactiveModal.showModal"
                :isActive="zoneMarkAsActiveInactiveModal.isActive"
                @closeClicked="zoneMarkAsActiveInactiveModal.showModal = false"
                @saveButtonClicked="onMarkAsActiveInactiveSaveClick"></mark-as-active-inactive-modal>
    
    <modal-form
            :heading="zoneAddEditFormModal.heading"
            :modalId="zoneAddEditFormModal.modalId"
            :isSaving="zoneAddEditFormModal.isSaving"
            :showModal="zoneAddEditFormModal.showModal"
            @closeClicked="onAddOrEditZoneModalCloseClick"
            @saveButtonClicked="onAddOrEditZoneSaveClick">
        <template #form>
            <form>
                <div class="form-group">
                    <label for="shippingZoneInput">
                        Shipping Zone
                    </label>
                    <div class="text-danger" v-if="zoneAddEditFormModal.zone.zone.hasError">
                        {{zoneAddEditFormModal.zone.zone.errorMessage}}
                    </div>
                    <input class="form-control" id="shippingZoneInput" v-model="zoneAddEditFormModal.zone.zone.value">
                </div>
            </form>
        </template>
    </modal-form>
</div>
